<template>
<div class="main">
    <div class="cbanner">
        <img src="../../../assets/images/banner_contact.jpg" />
        <div class="btext">
            <h3>政策法规</h3>
            <p>以客户为本，真诚服务，持续创新，追求卓越</p>
        </div>
    </div><!-- channel banner END-->
    <div class="main_inner">

        <el-breadcrumb separator-class="el-icon-arrow-right">
            <span class="btitle">当前位置：</span>
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>政策法规</el-breadcrumb-item>
            <el-breadcrumb-item>政策法规</el-breadcrumb-item>
        </el-breadcrumb>

        <el-row>
            <el-col :span="5" class="leftside">
                <el-menu
                        default-active="1"
                        class="el-menu-vertical-demo">
                    <router-link :to="{path:'/policiesRegulations'}">
                        <el-menu-item index="1"><span slot="title">政策法规</span></el-menu-item>
                    </router-link>
                    <router-link :to="{path:'borrowingKnowledge'}">
                        <el-menu-item index="2"><span slot="title">借贷知识</span></el-menu-item>
                    </router-link>
                </el-menu>
            </el-col>
            <el-col :span="19">
                <div class="con_right">
                    <div class="news_detail">
                        <h1 class="title_news" v-if="showDetail">{{this.policiesRegulationsDetail.title}}</h1>
                        <div class="date_news" v-if="showDetail">发布日期：{{this.policiesRegulationsDetail.publishTime|date_from_unix_YearMonthDay}} &nbsp;&nbsp;&nbsp;&nbsp;发布人：{{this.policiesRegulationsDetail.publisher}}</div>
                        <div class="content_news" v-html="policiesRegulationsDetailBody"></div>
                    </div>
                    <div class="news_more" v-if="showDetail">
                        <a class="prev" v-on:click="getPrevious(policiesRegulationsDetail.rownum)" v-bind:class="{temporary: policiesRegulationsDetail.rownum==1}"><b>上一篇：</b>{{this.policiesRegulationsDetail.rownum==1?'没有上一篇':perviousTitle}}</a>
                        <a class="next" v-on:click="getNext(policiesRegulationsDetail.rownum)" v-bind:class="{temporary: policiesRegulationsDetail.rownum==this.lastOne}"><b>下一篇：</b>{{this.policiesRegulationsDetail.rownum==this.lastOne?'没有下一篇':nextTitle}}</a>
                        <div class="clear"></div>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div><!-- main intro END -->
</div>
</template>

<script>
    import {reqPoliciesRegulationsDetailById,reqPervious,reqNext} from '../../../api/contentManagement-api.js'
    export default {
        data(){
            return{
                showDetail:true,
                policiesRegulationsDetail:{},
                policiesRegulationsDetailBody:'',
                perviousTitle:'',
                nextTitle:'',
                lastOne:'',
                form:{

                },
            }
        },
        methods:{
          getPoliciesRegulationsDetail(id){
              reqPoliciesRegulationsDetailById({id:id}).then((res)=>{
                  if(res.data.code===1){
                      this.policiesRegulationsDetail=res.data.data;
                      this.policiesRegulationsDetailBody=res.data.data.content;
                        this.getPerviousTitle(this.policiesRegulationsDetail.rownum);
                        this.getNextTitle(this.policiesRegulationsDetail.rownum);
                  }else {
                      this.policiesRegulationsDetailBody='<p>抱歉，暂无数据</p>';
                      this.showDetail=false;
                  }
              })
          },
  // 通过rownum拿到上下篇标题
            getPerviousTitle:function (rownum) {
                reqPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                    }
                })
            },
            getNextTitle:function (rownum) {
                reqNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.nextTitle=res.data.data.title;
                    }
                })
            },

//   上下篇内容
            getPrevious:function (rownum) {
                reqPervious({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.policiesRegulationsDetail=res.data.data;
                        this.policiesRegulationsDetailBody=res.data.data.content;
                        this.getPerviousTitle(this.policiesRegulationsDetail.rownum);
                        this.getNextTitle(this.policiesRegulationsDetail.rownum);
                    }
                })
            },
            getNext:function (rownum) {
                reqNext({rownum:rownum}).then((res)=>{
                    if(res.data.code===1){
                        this.perviousTitle=res.data.data.title;
                        this.policiesRegulationsDetail=res.data.data;
                        this.policiesRegulationsDetailBody=res.data.data.content;
                        this.getPerviousTitle(this.policiesRegulationsDetail.rownum);
                        this.getNextTitle(this.policiesRegulationsDetail.rownum);
                    }
                })
            },

        },
        mounted(){
         var total=this.$route.query.total;
         this.lastOne=total;
         var id=this.$route.query.id;
          this.getPoliciesRegulationsDetail(id);
        },
    }

</script>
<style>
    .news_more {
        line-height: 1.6em; padding:24px 0; margin-top:24px;
    }
    .prev {
        float: left;
    }
    .next {
        float: right; text-align: right;
    }
    .temporary {
        pointer-events: none;
        filter: alpha(opacity=50); /*IE滤镜，透明度50%*/
        -moz-opacity: 0.5; /*Firefox私有，透明度50%*/
        opacity: 0.5; /*其他，透明度50%*/
    }
</style>


// WEBPACK FOOTER //
// src/components/contentManagement/policiesRegulations/PoliciesRegulationsDetail.vue